import { Component, OnInit, Input, OnDestroy} from '@angular/core';
import { FobpointService } from './fobpoint.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppMainComponent } from 'src/app/app.main.component';
import { SetupService } from '../setup.service';
import {ObjectNames,Status,Severity,Answer} from '../../constants/constants';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-fobpoint',
  templateUrl: './fobpoint.component.html',
  styleUrls: ['./fobpoint.component.scss'],
})
export class FobpointComponent implements OnInit, OnDestroy {

  fobPointForm: FormGroup;
  allFOBPoints: any[] = [];
  addEditFOBHeader: string;
  displayFOBAdd: boolean = false;
  isAddFOBPoint: boolean = false;
  invalidData: boolean=false;
  statusDisabled: boolean =false;
  statusConstants= Status;
  answertypeConstants = Answer;
  @Input() financialAccounts: any[] =[];

  constructor(private fobService: FobpointService, private confirmationService: ConfirmationService, private messageService: MessageService,
    private fb: FormBuilder, private app: AppMainComponent, private setupService: SetupService,private titlecasePipe: TitleCasePipe) { }

  ngOnInit(): void {
    this.setupService.getFOBPoint().subscribe(term => {
      if (term) {
        this.showAddFOB();
      }
    })
    this.fobPointForm = this.fb.group({
      id: [0],
      createdSource: [''],
      updatedSource: [''],
      createdBy: [''],
      updatedBy: [''],
      createdDate: [''],
      updatedDate: [''],
      organizationId: [''],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      financialAccountId: [0, [Validators.required]],
      description: [''],
      isDefault: [false],
      statusId: [true],
    });
    this.loadFOBList();
  }

  loadFOBList() {
    this.fobService.getFOBList().subscribe((points) => {
      if(points){
        this.allFOBPoints = points;
      }
    })
  }

  showAddFOB() {
    this.addEditFOBHeader = ObjectNames.setupConstants.AddFOBTitle;
    this.isAddFOBPoint = true;
    this.statusDisabled=false;
    this.displayFOBAdd = true;
    this.invalidData=false;
    this.fobPointForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      organizationId: [this.app.companyId],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      financialAccountId:[this.getShippingAccount(),[Validators.required]],
      description: [''],
      isDefault: [false],
      statusId: [true],
    });
  }

  getShippingAccount(){
    const incomeAccount = this.financialAccounts?.filter(acc=> acc.labelName==ObjectNames.setupConstants.incomeAccount)[0];
    return (incomeAccount.children?.filter(child=> child.labelName==ObjectNames.setupConstants.shippingAccount)[0]);
  }

  showEditFOB(fob) {
    this.addEditFOBHeader = ObjectNames.setupConstants.EditFOBTitle;
    this.displayFOBAdd = true;
    this.invalidData=false;
    this.isAddFOBPoint = false;
    this.fobPointForm.patchValue(fob);
    //For Parent Financial Account
    const filteredFinancialId = this.financialAccounts?.filter(finance => finance.value?.id ==  fob.financialAccountId)[0];
    this.fobPointForm.controls['financialAccountId'].setValue(filteredFinancialId);
    //For Child Financial Account
    this.financialAccounts.forEach(finance => {
      const childAccount = finance.children?.filter(
        (child) => child.value?.id == fob.financialAccountId
    )[0];
    if (childAccount) {
     this.fobPointForm.controls['financialAccountId'].setValue(childAccount);
    }
    });
    //For Sub-Child Financial Account
     this.financialAccounts.forEach(finance => {
      finance.children?.forEach(element => {
        const subChildAccount = element.children?.filter(
          (child) => child.value?.id == fob.financialAccountId
      )[0];
      if (subChildAccount) {
       this.fobPointForm.controls['financialAccountId'].setValue(subChildAccount);
      }
      });
    });
    //For forth level Financial Account
    this.financialAccounts.forEach(finance => {
      finance.children?.forEach(fnc => {
        fnc.children?.forEach(element => {
          const forthLevelChildAccount = element.children?.filter(
            (child) => child.value?.id == fob.financialAccountId
          )[0];
          if (forthLevelChildAccount) {
            this.fobPointForm.controls['financialAccountId'].setValue(forthLevelChildAccount);
          }
        });
      });
    });
    this.fobPointForm.controls['statusId'].setValue(fob.statusId == Status.ACTIVE);
    if(fob.isDefault){
      this.statusDisabled=true;
    }else{
      this.statusDisabled=false;
    }
  }

  saveFOB(value) {
    this.invalidData=false;
    value.statusId = (value.statusId == true ? Status.ACTIVE : Status.INACTIVE);
    value.financialAccountId = value.financialAccountId?.value?.id;
    value.description = value.name;
    const lowerCaseNames = [];
    if (this.isAddFOBPoint) {
      for (let s of this.allFOBPoints) {
        lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ''))
      }
      if (lowerCaseNames.indexOf(value.name.toLowerCase().replace(/ /g, '')) > -1) {
        this.invalidData = true;
      } else {
        this.fobService.addFOB(value).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'FOB Point Added successfully...' });
          this.loadFOBList();
          this.displayFOBAdd = false;
        }).catch(() => {
          this.displayFOBAdd = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
      }
    } else {
      const duplicateRecord = this.allFOBPoints.find(depOb => depOb.name.toLowerCase().replace(/ /g, '') == value.name.toLowerCase().replace(/ /g, '') && depOb.id !== value.id)
      if (duplicateRecord) {
        this.invalidData = true;
      } else {
        this.invalidData = false;
        value.updatedBy = this.app.userId;
        value.updatedDate = new Date().toISOString();
        value.updatedSource = this.app.userIP;
        this.fobService.updateFOB(value).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'FOB Point Updated successfully...' });
          this.loadFOBList();
          this.displayFOBAdd = false;
        }).catch(() => {
          this.displayFOBAdd = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
      }

    }

  }

  deleteFOB(fob) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this FOB Point?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.fobService.deleteFOB(fob.id).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          const index = this.allFOBPoints.indexOf(fob);
          this.allFOBPoints.splice(index, 1);
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  fobDefault(fob){
   this.fobService.updateFOB(fob).then(() => {
    this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'FOB Point Updated successfully...' });
    this.loadFOBList();
    this.displayFOBAdd = false;
  }).catch(() => {
    this.displayFOBAdd = false;
    this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
  });
  }

  ngOnDestroy(): void 
  {
    this.setupService.setFOB('');
  }

}
